import type { RouteRecordRaw } from 'vue-router';

export const authRoutes: RouteRecordRaw[] = [
  {
    path: '/login',
    name: 'auth.login',
    component: () => import('@/auth/LoginPage.vue'),
    meta: {
      permission: null,
      data_scope: null,
      lazy_chunk_name: 'auth-login',
      title: '登录',
    },
  },
  {
    path: '/sso/callback',
    name: 'auth.sso-callback',
    component: () => import('@/auth/SsoCallback.vue'),
    meta: {
      permission: null,
      data_scope: null,
      lazy_chunk_name: 'auth-sso',
      title: 'SSO 回调',
    },
  },
];
